import type { HTMLAttributes } from 'react';

import { cn } from '../lib/cn';

/**
 * Emplacement grisé qui pulse en attendant les données. Sa taille et sa forme
 * viennent des classes : on le dimensionne comme le contenu qu'il remplace, pour
 * que la page ne saute pas à l'arrivée des données.
 */
export function Skeleton({ className, ...props }: HTMLAttributes<HTMLSpanElement>) {
  return (
    <span
      aria-hidden="true"
      className={cn('block animate-pulse rounded bg-border-subtle/60', className)}
      {...props}
    />
  );
}
